import "moment/locale/fr";
import "./ExternalTraining.scss";
import InfoContext from "pages/InfoContext";
import { FormattedMessage } from "react-intl";
import { Table } from "core/table/Table";
import { Typography } from "core/typography/Typography";
import { useContext } from "react";
import { useUserContext } from "api/user/UserProvider";
import { getFormattedDate } from "utils/functions";
import Icon from "core/icon/Icon";

const ExternalTraining = () => {
  const {
    externalTraining,
    openManageExternalTrainingModal,
    setOpenManageExternalTrainingModal,
  } = useContext(InfoContext);
  const { lang } = useUserContext();

  const booleanFormatter = (value) =>
    value ? (
      <FormattedMessage id="yes" defaultMessage="Oui" />
    ) : (
      <FormattedMessage id="no" defaultMessage="Non" />
    );

  const formatExternalTraining = (data) =>
    data.map((elm) => ({
      title: elm.title,
      provides_certificate: elm.provides_certificate || "-",
      mandatory:
        typeof elm.mandatory === "boolean"
          ? booleanFormatter(elm.mandatory)
          : "-",
      duration: elm.duration,
      start_date: getFormattedDate(elm.start_date, lang),
      end_date: getFormattedDate(elm.end_date, lang),
      funding_type: elm.funding_type,
    }));

  const createHeaderItem = (key, id, defaultMessage, icon, width) => ({
    label: {
      key,
      value: <FormattedMessage id={id} defaultMessage={defaultMessage} />,
    },
    icon,
    width,
  });

  const header = [
    createHeaderItem("title", "training_label", "Formation", "book", "26%"),
    createHeaderItem(
      "provides_certificate",
      "certificate_label",
      "Certificat",
      "book",
      "10%"
    ),
    createHeaderItem(
      "mandatory",
      "required_label",
      "Obligatoire",
      "check-list",
      "12%"
    ),
    createHeaderItem("duration", "duration_label", "Durée (h)", "time", "10%"),
    createHeaderItem("start_date", "start", "Début", "calendar", "10%"),
    createHeaderItem("end_date", "end", "Fin", "calendar", "16%"),
    createHeaderItem(
      "funding_type",
      "funding_label",
      "Financement",
      "salary",
      "16%"
    ),
  ];
  return (
    <div className="section">
      <div className="title-wrapper">
        <Typography
          className="title-3 violet text-uppercase"
          type="h2"
          label={
            <FormattedMessage
              id="external_training_title"
              defaultMessage="Formations externes"
            />
          }
        />
        <button
          className="manage-external-training-btn"
          onClick={() =>
            setOpenManageExternalTrainingModal(!openManageExternalTrainingModal)
          }
        >
          <Icon color="deep-purple" icon="book" width={25} marginRight={8} />
          <Typography
            className="link-1 violet "
            type="h2"
            label={
              <FormattedMessage
                id="manage_external_training"
                defaultMessage="Gérer les formations externes"
              />
            }
          />
        </button>
      </div>

      <div>
        <Table
          id="external_training"
          header={header}
          content={formatExternalTraining(externalTraining)}
        />
      </div>
    </div>
  );
};

export default ExternalTraining;
